import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import Toasted from "vue-toasted";
import router from "./router";
import store from "./store";
import moment from "moment";
import "./plugins/apexChart";
import "./scss/main.scss";

Vue.config.productionTip = false;
Vue.use(Toasted);
Vue.prototype.moment = moment;

if (process.env.VUE_APP_NODE_ENV === "production") {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

new Vue({
  store,
  vuetify,
  router,
  render: (h) => h(App),
}).$mount("#app");
